import type { ReactNode } from 'react'
import { createContext, useContext, useState } from 'react'

const LoginModalContext = createContext({
  visible: false,
  openLoginModal: () => {},
  closeLoginModal: () => {},
})

export const LoginModalProvider = ({ children }: { children: ReactNode }) => {
  const [visible, setVisible] = useState(false)

  const openLoginModal = () => setVisible(true)
  const closeLoginModal = () => setVisible(false)

  return (
    <LoginModalContext.Provider value={{ visible, openLoginModal, closeLoginModal }}>
      {children}
    </LoginModalContext.Provider>
  )
}

export const useLoginModal = () => useContext(LoginModalContext)
